import axios from "axios";
import { getAdminToken } from "../utils/adminAuth";

const addAdminHeader = (config) => {
  const token = getAdminToken();
  if (token) config.headers["X-Admin-Token"] = token;
  return config;
};

export const searchAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/search/`,
});
searchAPI.interceptors.request.use(addAdminHeader);

export const languageAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/language/`,
});
